import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { EntityRoute, OrdersRoutePathName } from '@/modules/to/order/order.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: EntityRoute.ENTITY_ORDERS,
      name: OrdersRoutePathName,
      component: () => import(/* webpackChunkName: "orderslist-page" */ './pages/OrderListPage'),
    },
    {
      path: `${EntityRoute.ENTITY_ORDERS}/create/:id?`,
      name: 'create-order',
      component: () => import(/* webpackChunkName: "create-order-page" */ './pages/OrderFormPage'),
      props: true,
    },
    {
      path: `${EntityRoute.ENTITY_ORDERS}/:id`,
      name: 'edit-entity-orders',
      component: () =>
        import(/* webpackChunkName: "order-details-page" */ './pages/OrderDetailsPage'),
      props: true,
    },
  ],
  Module.ORDER
);
